import React from 'react'
import styled from 'styled-components'
import { useDutyModalStore } from '../../store/dutyModal'
import { ActivitySearch } from './ActivitySearch'
import BackButton from './BackButton'
import CreateButton from './CreateButton'
import ActivityFilter from './activityFilter/ActivityFilter'

const TableActions: React.FC = () => {
  const query = useDutyModalStore((store) => store.variables?.filterBy?.query)
  return (
    <StyledWrapper>
      <ActivitySearch />
      <div className="right-section">
        <ActivityFilter />
        {query ? <BackButton /> : <CreateButton />}
      </div>
    </StyledWrapper>
  )
}

export default TableActions

const StyledWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  margin-bottom: 8px;

  > .right-section {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  & * {
    height: inherit;
  }
`
